export const TOKEN_COOKIE_NAME = "perses_token";
export const INVALID_TOKEN_ERROR_MESSAGE = "Invalid Perses' Token";
